import SoftButton from "components/SoftButton";
import React, { useState } from "react";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import { useAppServices, useUploadImage } from "hook/services";
import { useAgencyInfo } from "context/agency";
import { Edit, EventNote, Note } from "@mui/icons-material";
import Editor from "../editor";
import { useLocation, useParams } from "react-router-dom";
import SoftInput from "components/SoftInput";

const TypeEditModal = ({ handleRefresh, data }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const params = useParams();
  const handlemodal = (event) => {
    event.stopPropagation();
    setOpenAddProduct(true);
  };
  const style = {
    width: 400,
  };
  function AddProduct({ open, onClose }) {
    const [agency] = useAgencyInfo();
    const { state } = useLocation();
    const [processing, setProcessing] = useState(false);
    const AppService = useAppServices();
    const handleSubmit = async (e) => {
      setProcessing(true);
      e.preventDefault();
      const payload = {
        title: e.target.title.value,
        agency_id: agency._id,
        _id: data._id,
      };
      const { response } = await AppService.notes_type.update({
        payload,
        toaster: true,
      });
      setProcessing(false);
      if (response) {
        onClose();
        handleRefresh();
      }
    };

    return (
      <SoftBox>
        <MDModal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <SoftBox role="form" component="form" onSubmit={handleSubmit} sx={style}>
            <SoftBox display="flex" alignItems="center" mb={2}>
              <SoftTypography variant="h6">Edit Type</SoftTypography>
            </SoftBox>
            <SoftBox>
              <SoftTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500", marginBottom: "10px" }}
              >
                Title
              </SoftTypography>
              <SoftInput
                defaultValue={data?.title}
                label="Title"
                placeholder="Title"
                name="title"
                fullWidth
              />
            </SoftBox>
            <SoftBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              sx={{ mt: 4, mb: 1 }}
            >
              <SoftBox>
                <SoftButton
                  variant="outlined"
                  color="white"
                  sx={{
                    mr: 2,
                    "&:hover": {
                      background: "white",
                    },
                  }}
                  size="small"
                  onClick={onClose}
                >
                  Cancel
                </SoftButton>
                <SoftButton
                  variant="outlined"
                  color="dark"
                  type="submit"
                  loading={processing}
                  disabled={processing}
                  size="small"
                >
                  Edit
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </MDModal>
      </SoftBox>
    );
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false);
  };
  return (
    <>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
      <Edit sx={{ cursor: "pointer" }} onClick={handlemodal} />

    </>
  );
};

export default TypeEditModal;
TypeEditModal.propTypes = {
  open: PropTypes.bool,
  handleRefresh: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
